const INDEX_KEY = 'ste.saves';
const DATA_PREFIX = 'ste.save.';

export function u8ToB64(u8) {
  const bytes = u8 instanceof Uint8Array ? u8 : new Uint8Array(u8);
  let bin = '';
  const step = 0x8000;
  for (let i = 0; i < bytes.length; i += step) {
    bin += String.fromCharCode(...bytes.subarray(i, i + step));
  }
  return btoa(bin);
}

export function b64ToU8(b64) {
  const bin = atob(String(b64 || ''));
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out;
}

export function listSaves() {
  try {
    const list = JSON.parse(localStorage.getItem(INDEX_KEY) || '[]');
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function readSave(id) {
  const raw = localStorage.getItem(DATA_PREFIX + id);
  if (!raw) return null;
  return b64ToU8(raw);
}

export function writeSave(id, name, data) {
  localStorage.setItem(DATA_PREFIX + id, u8ToB64(data));
  const list = listSaves().filter((s) => s.id !== id);
  list.unshift({ id, name: name || 'Untitled', savedAt: Date.now() });
  localStorage.setItem(INDEX_KEY, JSON.stringify(list));
}

export function deleteSave(id) {
  localStorage.removeItem(DATA_PREFIX + id);
  localStorage.setItem(INDEX_KEY, JSON.stringify(listSaves().filter((s) => s.id !== id)));
}

export function newSaveId() {
  return `p${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
}
